/* BIZORA COD PRO - carrito: regalo automático, recomendados y código de descuento.
   Sin dependencias. Se protege contra doble carga. */
(function () {
  if (window.__bzCartLoaded) return;
  window.__bzCartLoaded = true;

  var routes = window.routes || {};
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function readConfig() {
    var el = document.querySelector('[data-bz-cart-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function parseSection(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  /* Repinta el drawer y el icono del carrito, o recarga si estamos en la página del carrito. */
  function refreshUI() {
    if (document.getElementById('main-cart-items')) {
      window.location.reload();
      return Promise.resolve();
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer && !document.getElementById('cart-icon-bubble')) return Promise.resolve();
    return fetch(root + '?sections=' + SECTIONS)
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var inner = document.getElementById('CartDrawer');
        if (inner && sections['cart-drawer']) {
          var d = parseSection(sections['cart-drawer'], '#CartDrawer');
          if (d) inner.innerHTML = d.innerHTML;
          if (drawer) {
            var empty = !d || !!d.querySelector('.is-empty, .drawer__inner-empty');
            drawer.classList.toggle('is-empty', empty);
            var overlay = drawer.querySelector('#CartDrawer-Overlay');
            if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var b = parseSection(sections['cart-icon-bubble'], '.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      })
      .catch(function () {});
  }

  /* ---------- Regalo automático ---------- */
  var gift = { busy: false, actions: 0, windowStart: Date.now(), timer: null };
  var FLAG = 'bz_gift_added';

  function flag(v) {
    try {
      if (v === undefined) return sessionStorage.getItem(FLAG) === '1';
      if (v) sessionStorage.setItem(FLAG, '1');
      else sessionStorage.removeItem(FLAG);
    } catch (e) {}
    return false;
  }

  function isGift(item) {
    return !!(item.properties && item.properties._bz_gift);
  }

  function syncGift() {
    var cfg = readConfig();
    if (!cfg.gift || !cfg.giftThreshold || !cfg.giftVariant || gift.busy) return;
    // Freno anti-bucle: como máximo 4 cambios de regalo cada 30 s.
    if (Date.now() - gift.windowStart > 30000) {
      gift.windowStart = Date.now();
      gift.actions = 0;
    }
    if (gift.actions >= 4) return;
    gift.busy = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var gifts = cart.items.filter(isGift);
        var value = cart.items.reduce(function (sum, i) {
          return isGift(i) ? sum : sum + i.final_line_price;
        }, 0);
        var realCount = cart.items.length - gifts.length;
        var qualifies = realCount > 0 && value >= cfg.giftThreshold;

        if (qualifies && !gifts.length) {
          // Si ya lo añadimos antes y no está, el cliente lo quitó: se respeta.
          if (flag()) return;
          gift.actions++;
          flag(true);
          return post(routes.cart_add_url ? routes.cart_add_url + '.js' : root + 'cart/add.js', {
            items: [{ id: cfg.giftVariant, quantity: 1, properties: { _bz_gift: 'true' } }],
          }).then(refreshUI);
        }
        if (!qualifies && gifts.length) {
          gift.actions++;
          flag(false);
          var updates = {};
          gifts.forEach(function (g) {
            updates[g.key] = 0;
          });
          return post(root + 'cart/update.js', { updates: updates }).then(refreshUI);
        }
        if (!qualifies) flag(false);
        if (qualifies && gifts.length && gifts[0].quantity > 1) {
          gift.actions++;
          return post(root + 'cart/change.js', { id: gifts[0].key, quantity: 1 }).then(refreshUI);
        }
      })
      .catch(function () {})
      .then(function () {
        gift.busy = false;
      });
  }

  function scheduleGift() {
    clearTimeout(gift.timer);
    gift.timer = setTimeout(syncGift, 500);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleGift);
  }
  document.addEventListener('DOMContentLoaded', scheduleGift);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) scheduleGift();
  });

  /* ---------- Upsell: añadir desde el carrito ---------- */
  function addUpsell(button) {
    var id = parseInt(button.getAttribute('data-bz-upsell-add'), 10);
    if (!id || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var onPage = !!document.getElementById('main-cart-items');
    var body = { items: [{ id: id, quantity: 1 }] };
    if (!onPage) body.sections = SECTIONS;
    post(routes.cart_add_url ? routes.cart_add_url + '.js' : root + 'cart/add.js', body)
      .then(function (res) {
        if (res.status && res.description) throw new Error(res.description);
        if (onPage) {
          window.location.reload();
          return;
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          res.id = res.items && res.items[0] ? res.items[0].id : id;
          drawer.renderContents(res);
        } else {
          refreshUI();
        }
        scheduleGift();
      })
      .catch(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }

  /* ---------- Código de descuento ---------- */
  function applyDiscount(scope) {
    var input = scope.querySelector('[data-bz-discount-input]');
    var code = input && input.value.trim();
    if (!code) {
      if (input) input.focus();
      return;
    }
    var back = window.location.pathname + window.location.search;
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-bz-upsell-add]');
    if (add) {
      e.preventDefault();
      addUpsell(add);
      return;
    }
    var apply = e.target.closest && e.target.closest('[data-bz-discount-apply]');
    if (apply) {
      e.preventDefault();
      applyDiscount(apply.closest('.bz-cart-discount'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-bz-discount-input]');
    if (!input) return;
    e.preventDefault();
    applyDiscount(input.closest('.bz-cart-discount'));
  });
})();
